import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import {
  MatDialog,
  MatPaginator,
  MatSort,
  MatTableDataSource,
  PageEvent,
} from "@angular/material";
import { NavigationExtras, Router } from "@angular/router";
import { AlertService } from "services/alert.service";
import { ApplicationService } from "services/application.service";
import { ExcelService } from "services/excel.service";
import { NavigationService } from "services/navigation.service";
import { UserService } from "services/user.service";
import { UserSessionService } from "services/usersession.service";
import swal from "sweetalert2";
import { ValoginComponent } from "../valogin/valogin.component";
import { ZoomactivatepopupComponent } from "../zoomactivatepopup/zoomactivatepopup.component";
import { ToastrService } from "ngx-toastr";
import { EftattachComponent } from "../eftattach/eftattach.component";
import Swal from "sweetalert2";

@Component({
  selector: "app-manageorder",
  templateUrl: "./manageorder.component.html",
  styleUrls: ["./manageorder.component.scss"],
})
export class ManageorderComponent implements OnInit, AfterViewInit {
  // manageOrderList: any[];

  data: any;
  dataSource = new MatTableDataSource();
  excelColumns: string[] = [];
  displayedColumns: string[] = [
    "serviceProvider",
    "customerName",
    "customerNumber",
    "resellerCode",
    "salesRepCode",
    "vumaApiReferenceNo",
    "vumaApiEasyPayNumber",
    "mobileNumber",
    "referenceNo",
    "productName",
    "networkIdentifier",
    "orderActivatedDate",
    "orderPlacedDate",
    "vumaApiResponseStatus",
    "address",
    "id",
  ];

  selectedServiceProvider: number | null = null;;
  selectedStatus: string | null = null;
  fromDate: string = "";
  toDate: string = "";
  maxDate: string = new Date().toISOString().split('T')[0];

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  mobileView: boolean = false;
  filterValue: string = "";
  productName: any;
  totalAmount: any;
  productSubCategory: any;
  isRecurringProduct: boolean = false;
  adminDetails: any;
  reason: any;
  datas1: string = " ";
  result: any;
  cancelstatus: any;
  renewed: any;
  application: any;
  applications: any;
  roleid: number;
  filterOpen: boolean = false;
  serviceProviderList: any;
  ApplicationStatusList: any;

  currentMode: 'default' | 'search' | 'filter' = 'default';
  currentSearchText: string = '';
  currentFilterPayload: any = null;
  currentPageIndex = 0;
  currentPageSize = 50;
  pageSizeOptions = [10, 25, 50, 100];
  totalRecords = 0;

  constructor(
    private applicationService: ApplicationService,
    public navigationService: NavigationService,
    private alertService: AlertService,
    private router: Router,
    private userSessionService: UserSessionService,
    private userService: UserService,
    public dialog: MatDialog,
    private toastr: ToastrService, private excelService: ExcelService, private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.getUserDetails(true);
    this.getLookUpList();
    this.filterValue = "";
    this.getmanageOrderList(true);

    // if (window.screen.width < 700) { // 768px portrait
    //   this.mobileView = true;
    // }
    // else
    // {
    //   this.mobileView = false;
    // }
    this.mobileView = false;
    this.roleid = this.userSessionService.roleId();
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.page.subscribe((event: PageEvent) => {
        this.onPageChange(event);
      });
    }
  }

  getmanageOrderList(refresh) {
    this.currentMode = 'default';
    this.currentSearchText = '';
    this.currentFilterPayload = null;
    this.currentPageIndex = 0;
    this.loadManageOrderData(refresh);
  }

  private loadManageOrderData(refresh: boolean) {
    const params = {
      pageNumber: this.currentPageIndex + 1,
      pageSize: this.currentPageSize,
    };
    console.log('loadManageOrderData', params, 'refresh=', refresh);

    this.applicationService.getManageOrderList(refresh, params).subscribe((result: any) => {
      const items = result && result.items ? result.items : (result || []);
      const totalCount = result && result.totalCount ? result.totalCount : (result ? result.length || 0 : 0);
      this.setTableData(items, totalCount);
    });
  }

  private loadSearchResults(refresh: boolean = false) {
    const params = {
      pageNumber: this.currentPageIndex + 1,
      pageSize: this.currentPageSize,
    };

    this.applicationService
      .applyFilter(this.currentSearchText, params)
      .subscribe((result: any) => {
        const items = result && result.items ? result.items : (result || []);
        const totalCount = result && result.totalCount ? result.totalCount : (result ? result.length || 0 : 0);
        this.setTableData(items, totalCount);
      });
  }

  private loadFilterResults(refresh: boolean = false) {
    const params = {
      pageNumber: this.currentPageIndex + 1,
      pageSize: this.currentPageSize,
    };
    const payload = {
      ...this.currentFilterPayload,
      ...params,
    };

    this.applicationService.getOrderListByFilterSearch(payload).subscribe((result: any) => {
      const value = result && result.value ? result.value : {};
      const items = value && value.items ? value.items : [];
      const totalCount = value && value.totalCount ? value.totalCount : 0;
      this.setTableData(items, totalCount);
    });
  }

  private setTableData(data: any[], totalCount: number) {
    this.data = data;
    this.totalRecords = totalCount;
    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.sort = this.sort;
    if (this.paginator) {
      this.paginator.length = this.totalRecords;
      this.paginator.pageIndex = this.currentPageIndex;
    }
  }

  exportToExcel() {

    debugger
    // Build the filter payload based on current filter values
    const exportPayload = {
      serviceProviderId: this.selectedServiceProvider,
      VumaApiResponseStatus: this.selectedStatus,
      startDate: this.fromDate ? new Date(this.fromDate).toISOString() : null,
      endDate: this.toDate ? new Date(this.toDate).toISOString() : null,
      searchText : this.filterValue ? this.filterValue : ''
    };

    // Call the new export API with the filter payload
    this.applicationService.getManageOrdersByFilterExport(exportPayload).subscribe(
      (result: any) => {
        if (!result || result.value.length === 0) {
          this.alertService.info("No data available to export");
          return;
        }

        const exportData = result.value.map((item: any) => ({
          customerName: item.customerName || "",
          customerCode: item.customerNumber || "",
          ResellerCode: item.resellerCode || "",
          ResellerSalesCode: item.resellerSalesCode || "",
          SalesRepCode: item.salesRepCode || "",
          contactNo: item.mobileNumber,
          applicationNo: item.referenceNo,
          serviceProvider: item.serviceProvider,
          productName: item.productName,
          creationDate: item.creationTs ? new Date(item.creationTs) : "",
          ActivatedDate: item.orderActivatedDate ? new Date(item.orderActivatedDate) : "",
          networkIdentifier: item.vumatelNetworkIdentifier || "",
          applicationStatus: item.vumatelApiResponseTypeName,
          orderNo: item.vumaApiReferenceNo || "",
          address: `${item.address || ""}${item.city ? ", " + item.city : ""}`,
        }));

        this.excelColumns = [
          "Customer Name",
          "Customer Code",
          "Reseller Code",
          "Reseller Sales Code",
          "Sales Rep Code",
          "Contact No",
          "Application No",
          "Service Provider",
          "Product Name",
          "Order Placed Date",
          "Order Activated Date",
          "Network Identifier / BNumber",
          "Application Status",
          "Order No",
          "Address"
        ];

        this.excelService.exportAsExcelFile(exportData, "ManageOrderExport", this.excelColumns);
      },
      (error: any) => {
        this.alertService.error("Error exporting data. Please try again.");
        console.error("Export error:", error);
      }
    );
  }

  getLookUpList() {
    this.userService.getServiceProviderType().subscribe((result) => {
      this.serviceProviderList = result;
    });

    this.userService.GetApplicationStatusType().subscribe((result) => {
      this.ApplicationStatusList = result;
    });
  }
  get(filter) {
    this.currentMode = 'search';
    this.currentSearchText = filter;
    this.currentPageIndex = 0;
    this.loadSearchResults();
  }

  onFilter() {
    if (this.filterValue == null || this.filterValue == '') {
      this.alertService.warning("Please enter the search text");
      return;
    }
    this.get(this.filterValue);
  }

  Search(filterValue: string) {
    this.filterValue = filterValue.trim();
  }

  onPageChange(event: PageEvent) {
    console.log('onPageChange', event);
    this.currentPageIndex = event.pageIndex;
    this.currentPageSize = event.pageSize;

    if (this.currentMode === 'search') {
      this.loadSearchResults();
    } else if (this.currentMode === 'filter') {
      this.loadFilterResults();
    } else {
      this.loadManageOrderData(false);
    }
  }

  onRefresh() {
    this.filterValue = "";
    this.currentMode = 'default';
    this.currentSearchText = '';
    this.currentFilterPayload = null;
    this.currentPageIndex = 0;
    this.getmanageOrderList(true);
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      if (this.filterValue == null || this.filterValue == '') {
        this.alertService.warning("Please enter the search text");
        return;
      }
      this.get(this.filterValue);
    }
  }
  onRenewPaymentLink(value) {
    const datas = {
      VumatelNetworkIdentifier: value.vumatelNetworkIdentifier,
      ReferenceNo: value.ReferenceNo,
      ApplicationId: value.id,
    };

    this.applicationService.renewPaymentLink(datas).subscribe((result) => {
      if (result) {
        swal.fire({
          text: "Renew paymet link has send to customer!",
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#d33",
          confirmButtonText: "Ok",
        });
      } else {
        swal.fire({
          title: "Oops! Something went wrong",
          text: result.value,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#d33",
          confirmButtonText: "Ok",
        });
      }
    });
  }

  retryOrderPlacement(row) {
    var paramFilters = {
      applicationId: row.id,
    };

    this.applicationService
      .postRetryOrderPendingApplication(paramFilters)
      .subscribe((result) => {
        if (result != null && result.value.vumaApiResponseStatus == 1) {
          this.alertService.success("Your request has accepted!");
          this.navigationService.goToDashboard();
        } else if (result != null && result.value.vumaApiResponseStatus == 2) {
          swal
            .fire({
              title: "Oops! Something went wrong",
              text: result.value.vumatelApiErrorMessage,
              icon: "error",
              showCancelButton: false,
              confirmButtonColor: "#d33",
              confirmButtonText: "Ok",
            })
            .then((res) => {
              if (res.value) {
                this.navigationService.goToDashboard();
              }
            });
        } else {
          this.alertService.warning("Some thing went wrong");
          this.navigationService.goToDashboard();
        }
      });
  }
  getUserDetails(refresh) {
    const userId = this.userSessionService.userId();
    this.userService.getUser(userId, refresh).subscribe((user) => {
      this.adminDetails = user;
      console.log(user);
    });
  }

  paymentUrl(value) {
    for (let index = 0; index < this.data.length; index++) {
      const element = this.data[index];
      if (value.id == element.id) {
        var url = element.paymentUrl;
        console.log(url);
        //  var user={
        //    Id:this.adminDetails.id,
        //    ApplicationId:value.referenceNo
        //  }
        this.userService.addToHistory(value.referenceNo).subscribe((result) => {
          console.log(result);
        });
        console.log("success");
        window.location.assign(url);
      }
    }
  }

  getPaymentLink(data) {
    this.datas1 = data.paymentUrl;
    console.log(data);
    swal
      .fire({
        title: "Credit Card Payment Link",
        input: "text", //data.paymentUrl,
        inputValue: this.datas1,
        // html: '<textarea>'+ data.paymentUrl+ '</textarea>',
        // input:data.paymentUrl,
        // icon: 'info',
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Copy",
        cancelButtonText: "Cancel",
      })
      .then((data) => {
        this.copyText(this.datas1);
      });
  }


  openServeInflightCancellation(data) {
    console.log("dataaaa  :: ", data)

    var payload = {
      orderId: data.vumaApiReferenceNo,
      referenceNumber: data.referenceNo,
    };

    this.applicationService.openServeInflightCancellation(payload).subscribe((res) => {
      if (res.isSuccess) {
        swal
          .fire({
            text: "Inflight cancellation logged successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#d33",
            confirmButtonText: "Ok",
          })
          .then((data) => {
            this.getmanageOrderList(true);
          });
      }
      else {
        this.alertService.error(res.HtmlFormattedFailures);
      }
    });


  }
  copyText(val: string) {
    let selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }

  moveTo(result) {
    swal
      .fire({
        title: "Payment Confirmation",
        text: "Are you sure, You want to move the order to payment successful?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes",
      })
      .then((res) => {
        if (res.value) {
          this.applicationService
            .changeStatusForZoom(result)
            .subscribe((res) => {
              swal
                .fire({
                  text: "Status Changed Successfully",
                  icon: "success",
                  showCancelButton: false,
                  confirmButtonColor: "#d33",
                  confirmButtonText: "Ok",
                })
                .then((res) => {
                  if (res.value) {
                    this.getmanageOrderList(true);
                  }
                });
            });
        }
      });
  }
  onSuccess(result) {
    if (result.vumaApiResponseStatus == 45 && result.serviceProviderId == 2) {
      var data = {
        networkIdentifier: result.vumatelNetworkIdentifier,
        ApplicationId: result.id,
      };
      this.applicationService.zoomNetworkSave(data).subscribe((res) => {
        if (res.isSuccess) {
          this.toastr.success("Status Changed Successfully");
          this.getmanageOrderList(true);
        } else {
          this.toastr.error(res.htmlFormattedFailures);
          this.getmanageOrderList(true);
        }
      });
    }
    else if (result.serviceProviderId == 4) {
      swal
        .fire({
          title: "Are you sure ",
          text: "You want to Activate the Voucher",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          confirmButtonText: "Ok",
        })
        .then((res) => {
          if (res.value) {
            var data = {
              networkIdentifier: result.vumatelNetworkIdentifier,
              ApplicationId: result.id,
            };
            this.applicationService.zoomNetworkSave(data).subscribe((res) => {
              if (res.isSuccess) {
                this.toastr.success("Status Changed Successfully");
                this.getmanageOrderList(true);
              } else {
                this.toastr.error(res.htmlFormattedFailures);
                this.getmanageOrderList(true);
              }
            });
          }
        });
    }
    else {
      const dialogRef = this.dialog.open(ZoomactivatepopupComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          appId: result.id,
          zoomact: true,
        },
      });
      dialogRef.afterClosed().subscribe((data) => {
        if (data == false) {
          this.getmanageOrderList(true);
        }
      });
    }
  }

  userLogin(value) {
    const dialogRef = this.dialog.open(ValoginComponent, {
      autoFocus: false,
      disableClose: true,
      width: "390px",
      data: {
        appId: value.id,
      },
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  onRejectOrder(item) {
    this.applicationService.getfailreasons(item.id).subscribe((res) => {
      this.reason = res;

      swal.fire({
        title: 'Reason for Failure',
        text: this.reason,
        icon: "info",
        showCancelButton: false,
        confirmButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
    });
  }
  getWifiDetails(item) {
    const dialogRef = this.dialog.open(ValoginComponent, {
      autoFocus: false,
      disableClose: true,
      width: "390px",
      data: {
        networkIdentifier: item.vumatelNetworkIdentifier,
        referncenumber: item.referenceNo,
        serviceId : item.serviceId
      },
    });
    dialogRef.afterClosed().subscribe((result) => { });

  }

  attachEFT(item) {
    const dialogRef = this.dialog.open(EftattachComponent, {
      autoFocus: false,
      disableClose: true,
      width: "400px",
      // height:"500px",
      data: {
        item,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        this.getmanageOrderList(true);
      }
    });
  }

  ondelete(data, number) {
    if (number == 1) {
      const dialogRef = this.dialog.open(ZoomactivatepopupComponent, {
        autoFocus: false,
        disableClose: true,
        width: "390px",
        data: {
          deletepage: true
        }

      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.reason != '' && result != true) {
          this.mainmethod(data, result.reason, number)
        }
        else {
          // this.getmanageOrderList(false);
        }
      });
    }
    else {
      swal
        .fire({
          title: "Are you sure?",
          text: "You want to delete",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          confirmButtonText: "Ok",
        })
        .then((res) => {
          if (res.value) {
            this.mainmethod(data, 'null', number)
          }
        });

    }
  }

  mainmethod(data, reason, number) {
    this.applicationService.deletetheorder(data, reason, number).subscribe(res => {
      this.cancelstatus = res;
      if (this.cancelstatus.isSuccess == true) {
        this.getmanageOrderList(true);
      }
    })
  }

  onrenewVoucher(data) {
    this.applicationService.getApplicationListByApplicationId(data.id).subscribe(result => {
      this.applications = result;

      if (this.applications != null) {
        this.application = this.applications[0];
        var detail = {
          voucherAppId: this.application.referenceNumber,
          vocuherproductname: this.application.productViewModel.name,
          voucherproductcost: this.application.productViewModel.cost,
          voucherexpirydate: this.application.vumaExpiryDate,
          downloadspeed: this.application.productViewModel.downloadSpeed,
          zoomVoucherActivate: true,
        }
        if (this.application.serviceProviderId != 4) {
          const dialogRef = this.dialog.open(ZoomactivatepopupComponent, {
            autoFocus: false,
            disableClose: true,
            maxWidth: '600px',
            data: {
              detail,
              zoomVoucherActivate: true,
            },
          });
          dialogRef.afterClosed().subscribe((datas) => {
            if (datas == false) {
              this.renewVoucher(data.id);
            }
          });
        }
        else {
          const dialogRef = this.dialog.open(ZoomactivatepopupComponent, {
            autoFocus: false,
            disableClose: true,
            maxWidth: '600px',
            data: {
              detail,
              Openserverenew: true,
            },
          });
          dialogRef.afterClosed().subscribe((datas) => {
            if (datas == false) {
              this.renewVoucher(data.id);
            }
          });
        }
      }
    });


  }

  renewVoucher(id) {
    this.applicationService.renewvoucher(id).subscribe(res => {
      this.renewed = res;
      if (this.renewed.isSuccess == true) {
        this.alertService.success("Order renewed successfully");
        this.getmanageOrderList(true);
      }
    })
  }

  toggleFilter() {
    this.filterOpen = !this.filterOpen;
  }

  applyFilter() {
    this.currentMode = 'filter';
    this.currentPageIndex = 0;
    this.currentFilterPayload = {
      serviceProviderId: this.selectedServiceProvider,
      VumaApiResponseStatus: this.selectedStatus,
      startDate: this.fromDate ? new Date(this.fromDate).toISOString() : null,
      endDate: this.toDate ? new Date(this.toDate).toISOString() : null,
    };

    this.loadFilterResults();
  }

  clearDateFilter() {
    this.selectedServiceProvider = null;;
    this.selectedStatus = null;
    this.fromDate = null;
    this.toDate = null;
  }

  onAddRepCode(datafield: any) {
    const dialogRef = this.dialog.open(ZoomactivatepopupComponent, {
      autoFocus: false,
      disableClose: true,
      width: '700px',
      maxWidth: '700px',
      data: {
        idToAddResellerOrSales: datafield.id,
        addResellerOrSalesRep: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == false) {
        this.getmanageOrderList(true);
      }
    });
  }
}
